import { AnimatePresence, motion } from "framer-motion";
import type { SpotlightEvent } from "../data/types";

export function Spotlight({ event }: { event: SpotlightEvent | null }) {
  const route = event ? buildRoute(event) : null;
  return (
    <AnimatePresence>
      {event && (
        <motion.div
          key={event.id}
          className="spotlight"
          initial={{ opacity: 0, y: 6, filter: "blur(6px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          exit={{ opacity: 0, y: -6, filter: "blur(6px)" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="spotlight-value">${formatAmount(event.amountUsd)}</div>
          {route && <div className="spotlight-route">{route}</div>}
          <div className="spotlight-pair">
            {event.currencySrc} <span className="arrow">→</span> {event.currencyDst}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

/** Build a human-readable route line: "Lagos → London" or "Alibaba" for card. */
function buildRoute(ev: SpotlightEvent): string | null {
  // Card spend with merchant — merchant is the story.
  if (ev.product === "card" && ev.merchant) return ev.merchant;
  // City-to-city route for sends.
  if (ev.originCity && ev.destCity && ev.originCity !== ev.destCity) {
    return `${ev.originCity} \u2192 ${ev.destCity}`;
  }
  return null;
}

function formatAmount(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + "M";
  if (n >= 10_000) return (n / 1000).toFixed(1) + "K";
  return Math.round(n).toLocaleString("en-US");
}
